import styled from "styled-components";

export const NonTimerCard = styled.div`
  display: flex;
  width: 100%;
  height: 3rem;
  gap: 1rem;
  background-color: #dc5c5c;
  color: white;
  align-items: center;
  border-radius: 0.25rem;
  font-size: 14px;
  font-weight: 500;
  padding-left: 0.5rem;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12),
    0px 1px 3px rgba(0, 0, 0, 0.2);

  svg {
    max-height: 20px;
  }
`;
